import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const CsatRateSchema = z.object({
  rating: z.number().min(1, "Rating is required"),
  comment: z.string(),
});

export type CsatRateFormData = z.input<typeof CsatRateSchema>;

export interface CsatRateFormReturn extends UseFormReturn<CsatRateFormData> {
  defaultValues: CsatRateFormData;
}

export const initialFormValues: CsatRateFormData = {
  rating: 0,
  comment: "",
};

export const useCsatRateForm = (
  initialValues?: CsatRateFormData,
): CsatRateFormReturn => ({
  defaultValues: initialValues || initialFormValues,
  ...useForm<CsatRateFormData>({
    mode: "onChange",
    defaultValues: initialValues,
    resolver: zodResolver(CsatRateSchema),
  }),
});
